import { Component } from 'react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { getBackendBaseUrl } from '../infrastructure/BackendUrlResolver';
import { Spinner } from '../uiComponents/Spinner';

export interface HangfireDashboardProps extends RouteComponentProps<any> {
}

class HangfireDashboard extends Component<HangfireDashboardProps, any> {
    componentDidMount() {
        window.location.href = getBackendBaseUrl() + '/hangfire';
    }
    
    render() {
        return <Spinner />;
    }
}

export default HangfireDashboard;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/HangfireDashboard.tsx